(function () {
  function syncVariantCard(input) {
    if (!input || !input.matches('.product-form__input--variant-cards input[type="radio"]')) return;

    var fieldset = input.closest('.product-form__input--variant-cards');
    if (!fieldset) return;

    fieldset.querySelectorAll('.variant-option-card.active').forEach(function (card) {
      card.classList.remove('active');
    });

    var label = null;
    fieldset.querySelectorAll('label[for]').forEach(function (candidate) {
      if (candidate.getAttribute('for') === input.id) {
        label = candidate;
      }
    });
    if (label) {
      label.classList.add('active');
    }

    var selectedValue = fieldset.querySelector('.option_value');
    if (selectedValue) {
      selectedValue.textContent = input.value;
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      syncVariantCard(event.target);
    },
    true
  );
})();
